 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		19: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		19: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"framework","2":"styles","3":"1bfc9850","4":"484bcb1e","5":"52066749","6":"777cf710","7":"7d0bf13e","8":"8673774c","9":"bda3ed4cb4d7a28e80a9621233c23a2a163da98d","10":"4a92b3dd67f93fb1b22db4ca2d63e747c200e7be","11":"1bf3280e945dc9ee3374d05b4db53a9cb122ecd3","12":"f0fb25a9ac8ddeeb2969c5e33aeaa3b9d87448cc","13":"cad54ee72e21498e7c10e13432ce029e769c135d","14":"7ab80424d077e483d977f4f704bb32a8e421f8ca","15":"aa6a5bc42e232abc232af9e0d47d1f69c578a3c3","16":"aaac74d7e2e9174dc32f5ae74c54dfabcbe01bb9","17":"b8f5e8ab377b8bd2ed1c532eaf6a884121dc5153","21":"component---src-pages-155-rumble-street-tsx","22":"component---src-pages-184-richmond-street-tsx","23":"component---src-pages-222-richmond-park-tsx","24":"component---src-pages-about-tsx","25":"component---src-pages-achievesmartgoals-tsx","26":"component---src-pages-advantage-tsx","27":"component---src-pages-aurora-tsx","28":"component---src-pages-brampton-tsx","29":"component---src-pages-charities-tsx","30":"component---src-pages-commercial-tsx","31":"component---src-pages-communities-tsx","32":"component---src-pages-contact-2-tsx","33":"component---src-pages-contact-tsx","34":"component---src-pages-developments-155-rumble-tsx","35":"component---src-pages-developments-184-richmond-tsx","36":"component---src-pages-developments-222-richmond-tsx","37":"component---src-pages-developments-lawrence-collec-tsx","38":"component---src-pages-developments-tsx","39":"component---src-pages-etobicoke-tsx","40":"component---src-pages-forgotpass-tsx","41":"component---src-pages-fourwaysprofit-tsx","42":"component---src-pages-index-tsx","43":"component---src-pages-journal-tsx","44":"component---src-pages-kingcity-tsx","45":"component---src-pages-lawrence-collection-tsx","46":"component---src-pages-listing-tsx","47":"component---src-pages-markham-tsx","48":"component---src-pages-newmarket-tsx","49":"component---src-pages-northyork-tsx","50":"component---src-pages-pandemicera-tsx","51":"component---src-pages-pickering-tsx","52":"component---src-pages-privacy-tsx","53":"component---src-pages-privacypolicy-tsx","54":"component---src-pages-properties-tsx","55":"component---src-pages-propmanagement-tsx","56":"component---src-pages-realestatebrand-tsx","57":"component---src-pages-richmondhill-tsx","58":"component---src-pages-stcaths-tsx","59":"component---src-pages-stouffville-tsx","60":"component---src-pages-team-tsx","61":"component---src-pages-termsservice-tsx","62":"component---src-pages-toronto-tsx","63":"component---src-pages-truecolours-tsx","64":"component---src-pages-vaughan-tsx"}[chunkId]||chunkId) + "-" + {"0":"557350aaf27b1d09944b","1":"66de534473b9f0aa3a52","2":"964a3e3d31e252edbea8","3":"3fb252907cee0f1dfaec","4":"9c76a1971f8600fd45b7","5":"82fe285a0d831a78878f","6":"1fd458dc8f199716f124","7":"25e7215ac565e0d92d33","8":"7d66862c2cf1fde09334","9":"a700029c765e59b57387","10":"93c1c3b2e72c1f0fcee2","11":"05b41e3a91176cfc1db8","12":"f73db2d1ac5be52d889c","13":"97cb77e7a548fe676b2c","14":"cd09914927a51c9e03fe","15":"bbd847cc1a06620b7d00","16":"b3d4eae5dace88ed975b","17":"b88a6e1658e11c6b3c5a","21":"45662427e64fc9c4c0a2","22":"5b07e9e2cf17255820ba","23":"1897f4e8f380b69ff249","24":"375831cdce284bd5b51f","25":"b6229574dce4688585ce","26":"ce8a8fb6a134eae6d241","27":"41b9dbf576345bf04aa5","28":"9621ab9361cb2affb8a5","29":"720c77ef2d4fb44eec6b","30":"95745a23f8d4053f34fb","31":"fdf29c14b6032f594418","32":"accc663e633610c42303","33":"68b14c44145460affb2d","34":"5015aff501e64c0a1127","35":"947cde94650d361464e9","36":"95faedcadf30f118228e","37":"8688bda0cb078f9c80d0","38":"7e52f13aebc99567d0cf","39":"cd17c9217d187105051c","40":"e42af83603f9048c2d31","41":"92c72255ba6a8e46db71","42":"f8b1086b0e6f55ddcc01","43":"8624117bc037c0d6e022","44":"fdcf95b0cced1ab101c1","45":"b7d9af2d7fac70105e97","46":"81dcc3aec140f371805f","47":"801afa07dd84285acf52","48":"24340c3579f37f24d28f","49":"53047a9aaf2799836ccf","50":"95545e547a44981aed86","51":"3367b128e6028325ea20","52":"8520775a93162ad5f81d","53":"d80430cda6718e139832","54":"bc80cb1024b0e9e1ac77","55":"224728864374a33b8bfd","56":"f488e269a5db8f37f91d","57":"ca870a910a3881d5468a","58":"add11854d5186a7896a3","59":"0a791e78a67d79a36c16","60":"71513b51c0c24cb36290","61":"8d520db3a682177597f1","62":"7fff216c115c506d5c33","63":"759a571b91d50989c18d","64":"e25bd60965ca9c8a2f94"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"framework","2":"styles","3":"1bfc9850","4":"484bcb1e","5":"52066749","6":"777cf710","7":"7d0bf13e","8":"8673774c","9":"bda3ed4cb4d7a28e80a9621233c23a2a163da98d","10":"4a92b3dd67f93fb1b22db4ca2d63e747c200e7be","11":"1bf3280e945dc9ee3374d05b4db53a9cb122ecd3","12":"f0fb25a9ac8ddeeb2969c5e33aeaa3b9d87448cc","13":"cad54ee72e21498e7c10e13432ce029e769c135d","14":"7ab80424d077e483d977f4f704bb32a8e421f8ca","15":"aa6a5bc42e232abc232af9e0d47d1f69c578a3c3","16":"aaac74d7e2e9174dc32f5ae74c54dfabcbe01bb9","17":"b8f5e8ab377b8bd2ed1c532eaf6a884121dc5153","21":"component---src-pages-155-rumble-street-tsx","22":"component---src-pages-184-richmond-street-tsx","23":"component---src-pages-222-richmond-park-tsx","24":"component---src-pages-about-tsx","25":"component---src-pages-achievesmartgoals-tsx","26":"component---src-pages-advantage-tsx","27":"component---src-pages-aurora-tsx","28":"component---src-pages-brampton-tsx","29":"component---src-pages-charities-tsx","30":"component---src-pages-commercial-tsx","31":"component---src-pages-communities-tsx","32":"component---src-pages-contact-2-tsx","33":"component---src-pages-contact-tsx","34":"component---src-pages-developments-155-rumble-tsx","35":"component---src-pages-developments-184-richmond-tsx","36":"component---src-pages-developments-222-richmond-tsx","37":"component---src-pages-developments-lawrence-collec-tsx","38":"component---src-pages-developments-tsx","39":"component---src-pages-etobicoke-tsx","40":"component---src-pages-forgotpass-tsx","41":"component---src-pages-fourwaysprofit-tsx","42":"component---src-pages-index-tsx","43":"component---src-pages-journal-tsx","44":"component---src-pages-kingcity-tsx","45":"component---src-pages-lawrence-collection-tsx","46":"component---src-pages-listing-tsx","47":"component---src-pages-markham-tsx","48":"component---src-pages-newmarket-tsx","49":"component---src-pages-northyork-tsx","50":"component---src-pages-pandemicera-tsx","51":"component---src-pages-pickering-tsx","52":"component---src-pages-privacy-tsx","53":"component---src-pages-privacypolicy-tsx","54":"component---src-pages-properties-tsx","55":"component---src-pages-propmanagement-tsx","56":"component---src-pages-realestatebrand-tsx","57":"component---src-pages-richmondhill-tsx","58":"component---src-pages-stcaths-tsx","59":"component---src-pages-stouffville-tsx","60":"component---src-pages-team-tsx","61":"component---src-pages-termsservice-tsx","62":"component---src-pages-toronto-tsx","63":"component---src-pages-truecolours-tsx","64":"component---src-pages-vaughan-tsx"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"9a2d06a85e4d54f284cd","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
